<template>
  <el-dialog
    title="编辑替代名"
    :visible.sync="dialog"
    width="500px"
    style="text-align: left"
    :close-on-click-modal="false"
    :before-close="close"
  >
    <div class="addbox">
      <div>
        <span>通用名：{{ nameData.generic_name }}</span>
      </div>
      <div style="margin: 15px 0 10px">
        <span style="margin-right: 10px">可代替药品</span>
        <el-button
          type="primary"
          size="mini"
          icon="el-icon-plus"
          @click="addReplace"
        >新增</el-button>
      </div>
      <div style="border: solid 1px #c9cbd6">
        <el-table
          ref="multipleTable"
          :data="replace_data"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="{ background: '#F5F5F5' }"
        >
          <el-table-column label="药品通用名">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.generic_name"
                placeholder="添加中药/简拼"
                class="name-input"
                clearable
                filterable
                remote
                :remote-method="remoteMedicine"
                value-key="generic_name"
                @focus="(item) => judeMedicine(item, scope.$index)"
                @change="(item) => selectMedicine(item, scope.$index)"
                @clear="(item) => clearMedicine(item, scope.$index)"
              >
                <i
                  slot="prefix"
                  class="el-input__icon el-icon-plus"
                />
                <el-option
                  v-for="item in drug_remote_list"
                  :key="item.drug_id"
                  :label="item.generic_name"
                  :value="item"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="60"
          >
            <template slot-scope="scope">
              <el-button
                icon="el-icon-delete"
                type="text"
                @click="delReplaceName(scope.$index)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div style="text-align: center; padding-bottom: 10px">
      <el-button
        @click="closeShow"
        style="width: 92px"
      >取 消</el-button>
      <el-button
        type="primary"
        @click="submit"
        style="width: 92px"
      >确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import _ from 'lodash';
export default {
  data() {
    return {
      replace_data: [
        {
          drug_id: '',
          generic_name: ''
        }
      ],
      generic_name: '',
      dialog: true,
      drug_remote_list: []
    };
  },
  props: ['nameData'],
  methods: {
    closeShow() {
      this.$emit('closeShow');
    },
    //获取列表
    getDrugTcmReplaceInfo() {
      let drug_id = this.nameData.drug_id;
      this.axios
        .post('platform/template/getDrugTcmReplaceInfo', { drug_id })
        .then((res) => {
          if (res.code == 0) {
            this.replace_data = res.data.list.map((item) => {
              item.replace_name = item.replace;
              return item;
            });
          }
        });
    },
    //提交
    submit() {
      let replace_data = this.replace_data.map((item) => {
        return item.drug_id;
      });
      let data = {
        drug_id: this.nameData.drug_id,
        replace_drug_ids: replace_data.toString()
      };
      this.axios
        .post('platform/template/saveReplaceDrugInfo', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('保存成功');
            this.closeShow();
          }
        });
    },
    //远程搜索药品
    remoteMedicine(keywords) {
      if (!keywords) {
        return;
      }
      let data = {
        simple_pname: keywords,
        page: 1,
        pageNumber: 10000
      };
      this.axios.post('platform/template/getDrugTcmList', data).then((res) => {
        this.drug_remote_list = res.data.list;
      });
    },
    //新增替代名
    addReplace() {
      if (this.replace_data.length == 5) {
        this.$message.error('最多添加5个替代名');
        return false;
      }
      //添加到第一个没有填写的格子
      let setIndex = this.replace_data.findIndex((ele) => {
        return !ele.drug_id;
      });
      if (setIndex != -1 && this.replace_data.length) {
        return false;
      }
      let data = {
        drug_id: '',
        generic_name: ''
      };
      this.replace_data.push(data);
    },
    //获取焦点时如果该栏没有药品，清空drug_remote_list，如果有药品，将drug_remote_list 等于该药品
    judeMedicine(item) {
      if (!item.generic_name) {
        this.drug_remote_list = [];
      } else {
        this.drug_remote_list = item;
      }
    },
    //选择药品
    selectMedicine(item, index) {
      if (!item.drug_id) return;
      let obj = {
        drug_id: item.drug_id,
        generic_name: item.generic_name
      };
      let medicine = JSON.parse(JSON.stringify(this.replace_data));
      let repetition = medicine.find((ele) => {
        return ele.generic_name && ele.generic_name == item.generic_name;
      });
      //暂时用空位占据
      this.replace_data.splice(index, 1, {
        drug_id: '',
        generic_name: ''
      });
      if (repetition && repetition.drug_id) {
        //重复不能添加
        this.$message({
          message: item.generic_name + '已经填写！',
          type: 'error'
        });
      } else {
        //添加到第一个没有填写的格子
        let setIndex = this.replace_data.findIndex((ele) => {
          return !ele.drug_id;
        });
        this.replace_data.splice(setIndex, 1, obj);
      }
    },
    //清空药品
    clearMedicine(item, index) {
      this.ruleForm.medicine.splice(index, 1);
      this.ruleForm.medicine.push({
        drug_id: '',
        generic_name: ''
      });
    },
    //删除
    delReplaceName(index) {
      this.replace_data.splice(index, 1);
    },
    close() {
      this.closeShow();
    }
  },
  created() {
    this.getDrugTcmReplaceInfo();
  }
};
</script>
<style lang="scss" scoped>
.addbox {
  padding: 20px;
  box-sizing: border-box;
}
</style>
